<div class="tag__content">
  {{ label }}
  <ng-content></ng-content>
</div>
